const handleMaintenanceStatusModal = {
  text1: 'Deseja realmente',
  text2: 'essa Manutenção?',
  confirm_title: 'MANUTENÇÃO',
  cancel: 'CANCELAR',
  send: 'ENVIAR',
  complete: 'CONCLUIR',
  reactivate: 'REATIVAR'
};

export default handleMaintenanceStatusModal;
